import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { NewsletterItemFacade } from './newsletter-item.facade';

@Injectable({
  providedIn: 'root',
})
export class NewsletterItemGuard {
  constructor(private newsletterItemFacade: NewsletterItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { newsletterItemId },
    } = route;
    return checkStoreState(this.newsletterItemFacade, newsletterItemId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.newsletterItemFacade);
  }
}
